import { chocotvWeb } from './index.js';
import pkg from '../../package.json';

export default {
  ...chocotvWeb,
  version: pkg.version,
  countryCode: 'TW',
  languageId: 'zh',
};
